import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles<{ firstLetterLower: boolean }>()(
  ({}, { firstLetterLower }) => ({
    tooltip: {
      [`&:first-letter`]: {
        textTransform: firstLetterLower ? "lowercase" : "none"
      }
    }
  })
)
